import React from 'react';
import './RuleTagEditor.sass';
import {List, Set} from 'immutable';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

const PLACEHOLDER = 'Create or search popular tags...';

interface RuleTagEditorProps {
  tags: Set<string>;
  defaultTags: List<string>;
  onChange: (tags: string[]) => void;
}

export default function RuleTagEditor(props: RuleTagEditorProps) {
  const {tags, defaultTags, onChange} = props;

  return (
    <div className="rule-tag-editor">
      <label>Add / Edit or Remove tags for this Trigger</label>
      <Autocomplete
        multiple
        freeSolo
        autoHighlight
        filterSelectedOptions
        forcePopupIcon
        disableClearable
        renderInput={params => (
          <TextField
            {...params}
            placeholder={tags.isEmpty() ? PLACEHOLDER : ''}
            size="small"
            variant="outlined"
          />
        )}
        value={tags.toJS()}
        options={defaultTags.toJS()}
        onChange={(e, values) => onChange(values)}
        ChipProps={{
          size: 'small',
          variant: 'outlined',
        }}
      />
    </div>
  );
}
